var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilePdf(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.063 .148)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#D50000",
    width: 32,
    height: 31.705,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.072 16.546c-.507-.434-1.013-.977-1.592-1.555-.398-.434-.832-1.05-1.194-1.7.688-2.351 1.013-4.594.29-5.679-.326-.506-.832-.76-1.483-.76-.724 0-1.266.326-1.52.94-.578 1.303.29 3.69 1.339 5.643a46.37 46.37 0 0 1-1.085 3.075 27.54 27.54 0 0 1-.832 1.808c-2.966 1.158-4.775 2.46-5.028 3.69-.108.578.073 1.085.579 1.483.29.217.615.361.977.361.144 0 .289-.036.434-.072 1.374-.362 2.857-2.387 3.942-4.449a20.54 20.54 0 0 1 2.243-.723c.976-.29 1.844-.507 2.604-.651 1.41 1.121 2.604 1.736 3.653 1.736.796.036 1.375-.253 1.917-.796.796-.796.47-1.483.362-1.664-.651-1.012-2.64-1.23-5.606-.687zm-9.477 5.968a.358.358 0 0 1-.29-.036c-.144-.109-.144-.18-.108-.253.072-.434.904-1.23 2.713-2.098-.868 1.302-1.736 2.242-2.315 2.387zM14.73 8.3c.036-.072.072-.18.362-.18.253 0 .362.108.434.18.325.47.29 1.664-.109 3.256-.615-1.375-.94-2.677-.687-3.256zm1.013 9.043-1.085.325c.108-.253.217-.506.325-.723.253-.687.543-1.375.796-2.098.29.398.543.76.796 1.013.325.362.65.687.976 1.013-.578.144-1.193.289-1.808.47zm7.632.65c-.253.29-.579.399-.977.399-.542 0-1.193-.253-1.953-.76 2.098-.29 3.291-.072 2.93.362z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.8380cebd.svg";
export { ForwardRef as ReactComponent };